import { connect } from 'react-redux';
import RegistrationCodeEditScreen from '../components/RegistrationCodeEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.registrationCodes.get('isLoading'),
    success: state.registrationCodes.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const RegistrationCodeEditScreenContainer = connect(mapStateToProps)(
  RegistrationCodeEditScreen
);

export default RegistrationCodeEditScreenContainer;
